import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTriggerModel } from '@apps-common/types/portal/unit-trigger'

export const updateUnitTrigger = async (model: IUnitTriggerModel): Promise<IUnitTriggerModel> =>
  axios.post(`/my-monitoring/sites/UpdateTrigger`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitTriggerModel
}

export const useMyMonitoringUpdateUnitTrigger = (notify?: boolean, onSuccess?: (data: IUnitTriggerModel) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringUnitTrigger'],
    mutationFn: ({ model }: Props) => updateUnitTrigger(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated trigger.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to updated trigger, please try again.')
      }
    },
    throwOnError: false
  })
